import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DTypeFormSelectField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol, SelectOptionGroup } from '@grupo-constant/next-dtype/types';
import { distinctUntilChanged, map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { LocalizePipe } from '../../../pipes/localize.pipe';
import { Utils } from '../../../utils/utils';

@Component({
    selector: 'select-group-field-component',
    templateUrl: './select-group-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeSelectGroupFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormSelectField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    displayedValue: string;
    filterControl = new FormControl<string>('');
    filteredGroups: Observable<SelectOptionGroup[]>;

    private _unsubscribeAll = new Subject<void>();

    constructor(private localize: LocalizePipe) { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
        this.displayedValue =  this.getDisplayValue(this.field.control.value);

        this.field.control.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                distinctUntilChanged()
            )
            .subscribe(value => this.displayedValue =  this.getDisplayValue(value));

        this.filteredGroups = this.filterControl.valueChanges.pipe(
            startWith(''),
            map((value: string) => this.field.groups.map((group) => {
                group.hide = !this.filterGroup(group, value);
                return group;
            }))
        );
    }

    private filterGroup(group: SelectOptionGroup, value: string) {
        for (const opt of group.option ?? []) {
            opt.hide = !Utils.removeAccents(this.localize.transform(opt.value)).toLowerCase().includes(Utils.removeAccents(value).toLowerCase());
        }
        return (group.option ?? []).some(opt => !opt.hide);
    }

    private getDisplayValue(value: string | string[]) {
        let displayValue = '';
        if (typeof value === 'string' && value.length > 0) {
            displayValue = this.getOptionLabel(value) ?? '';
        } else if (Array.isArray(value) && value.length > 0) {
            let optionLabel = '';
            for (const code of value) {
                optionLabel = this.getOptionLabel(code);
                if (optionLabel) {
                    if (displayValue.length > 0) {
                        displayValue += ', ';
                    }
                    displayValue += optionLabel;
                }
            }
        }
        if (!displayValue && ((Array.isArray(value) && value.length > 0) || value)) {
            this.field.control.setValue(undefined, { emitEvent: false });
        }
        return displayValue;
    }

    private getOptionLabel(code: string) {
        if (!code) {
            return null;
        }
        const options = [].concat(...this.field.groups.map(o => o.option));
        const option = options.find(o => o.code === code);
        return option ? this.localize.transform(option.value) : null;
    }

}
